import {NumberPlate} from '@App/types'


export const useNumberPlate = () => {

    const formatNumberPlate = (numberPlate: NumberPlate): string => {
        if (numberPlate.region && numberPlate.firstID && numberPlate.secondID) {
            return numberPlate.region + '-' + numberPlate.firstID + ' ' + numberPlate.secondID;
        }
        return null
    }

    return {
        formatNumberPlate
    }
}
